import React, { useContext } from "react";
import "./home-style.css";
import LanguageContext from "../../context/LanguageContext";

const jsonDataEn = require("./data/home-data-en.json");
const jsonDataFr = require("./data/home-data-fr.json");

const Hero = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data.hero : jsonDataFr.data.hero;

  return (
    <div className="home-hero">
      <div className="home-hero-content">
        <h1 className="home-hero-title">
          {data.title1} <br />
          {data.title2}
        </h1>
        <p className="home-hero-description">{data.description}</p>
        <a href="#contact" className="home-hero-btn">
          {data.btn}
        </a>
        <img src="assets/home/1stHero_devices.webp" alt="Tablet showcasing app" className="hero-image" />
      </div>
    </div>
  );
};

export default Hero;
